<template>
  <div class="py-3">
    <h5 class="card-text mb-5">
      Creative Properties
    </h5>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('backgroundColour')"
    >
      <div class="row align-items-center">
        <label class="col-sm-10 form-label">Background Colour:</label>
        <div class="col-sm-2 input-group-sm">
          <BaseColourSelect
            v-model="creativeSettings.backgroundColour"
            @change="onSubmitSetting()"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('clientName')"
    >
      <div class="row align-items-center">
        <label class="col-sm-4 form-label">Client Name:</label>
        <div class="col-md-8 input-group-sm">
          <b-form-input
            v-model="creativeSettings.clientName"
            trim
            data-test="client-name"
            @blur="onSubmitSetting()"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <logo-upload
      v-if="GET_IS_SELF_SERVICE_CAMPAIGN"
      logo-type="master"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

import LogoUpload from '@/modules/content/components/PreviewRightPanel/LogoUpload';

export default {
  name: 'CreativeProperties',
  components: {
    LogoUpload,
  },
  data() {
    return {
      creativeTemplateId: 0,
      templateOptions: [],
    };
  },
  props: {
    creativeSet: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Array,
      default: () => [],
    },
    creativeSettings: {
      type: Object,
      default: () => {},
    },
    editableProperties: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_READ_ONLY,
      campaignTypes.GET_IS_SELF_SERVICE_CAMPAIGN,
    ]),
  },
  methods: {
    onSubmitTemplate() {
      const payload = {
        creativeTemplateId: this.creativeTemplateId,
      };
      this.$emit('submit', payload);
    },
    onSubmitSetting() {
      const payload = {
        ...this.creativeSettings,
      };
      this.$emit('submit', payload);
    },
    isReadOnly(property) {
      return this.readOnly.includes(property) || this.GET_IS_READ_ONLY(property);
    },
    isEditableProperty(property) {
      return this.editableProperties.includes(property);
    },
  },
};
</script>
